import { useEffect, useState } from 'react'
import { consumirApi } from '../../../utils/consumoApi'
import { agregarDatosEmpresaUsuario } from '../../../utils/empresaUsuario'
import ErrorAlert from '../../../components/common/ErrorAlert'
import Table from '../../../components/tables/TableFilter'
import Button from '../../../components/common/Button'
import Modal from '../../../components/modals/Modal'
import ModalConfirmacion from '../../../components/modals/ModalConfirmacion'
import Form from '../../../components/forms/Form'
import Input from '../../../components/common/Input'
import Notification from '../../../components/common/Notification'
import Spinner from '../../../components/common/Spinner'

const Ubicacion = () => {
    const [datos, setDatos] = useState([])
    const idEmpresa = JSON.parse(localStorage.getItem('empresa'))
    // campos 
    const [idUbicacion, setIdUbicacion] = useState("")
    const [departamento, setDepartamento] = useState("")
    const [provincia, setProvincia] = useState("")
    const [ciudad, setCiudad] = useState("")
    const [costoViatico, setCostoViatico] = useState("")
    // modales
    const [mostrarModal, setMostrarModal] = useState(false)
    const [mostrarModalEditar, setMostrarModalEditar] = useState(false)
    const [mostrarModalEliminar, setMostrarModalEliminar] = useState(false)
    // notificaciones y cargas 
    const [error, setError] = useState("")
    const [cargando, setCargando] = useState(true)
    const [notificacion, setNotificacion] = useState({ estado: false, tipo: "", mensaje: "" })
    const [isSubmitting, setIsSubmitting] = useState(false)
    //seleccion de fila
    const [selectedId, setSelectedId] = useState(null)
    //datos para la tabla
    const columnas = [
        { titulo: 'Departamento', campo: 'departamento' },
        { titulo: 'Provinca', campo: 'provincia' },
        { titulo: 'Ciudad', campo: 'ciudad' },
        { titulo: 'Costo viaticos', campo: 'costo_viatico' },
    ]

    // Carga inicial de las ubicaciones
    useEffect(() => { obtenerUbicacion() }, [])

    // Función para traer las ubicaciones
    const obtenerUbicacion = async () => {
        const respuesta = await consumirApi('GET', `maestros/ubicacion/${idEmpresa}`)
        setDatos(respuesta.success ? respuesta.data : respuesta.error)
        setCargando(false)
    }

    // Registro de una nueva ubicación
    const registrarUbicacion = (async (e) => {
        e.preventDefault()
        const formData = new FormData(e.target)
        agregarDatosEmpresaUsuario(formData)
        setIsSubmitting(true)
        const respuesta = await consumirApi('POST', `maestros/ubicacion`, formData)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "registro", mensaje: "ubicación registrada correctamente" })
            limpiarCampos()
            obtenerUbicacion()
        }
        else {
            setError(respuesta.error)
            setIsSubmitting(false)
        }
    })

    // funcion para abrir el modal para editar ubicacion
    const abrirModalEditar =(data) => {
        setIdUbicacion(data.id)
        setDepartamento(data.departamento)
        setProvincia(data.provincia)
        setCiudad(data.ciudad)
        setCostoViatico(data.costo_viatico)
        setMostrarModalEditar(true)
    }

    // Edición ubicación
    const enviarEdicionUbicacion = async (e) => {
        e.preventDefault()
        const data = { departamento, provincia, ciudad, costo_viatico: costoViatico }
        setIsSubmitting(true)
        const respuesta = await consumirApi('PATCH', `maestros/ubicacion/${idUbicacion}`, data)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "actualizacion", mensaje: "Ubicación actualizada correctamente" })
            limpiarCampos()
            obtenerUbicacion()
        } else {
            setError(respuesta.error)
            setIsSubmitting(false)
        }
    }

    // Manejar selección de checkbox
    const seleccionUbicacion = (data) => {
        setSelectedId((prevSelectedId) => (prevSelectedId === data.id ? null : data.id))
    }

    // funcion para abrir el modal para editar accion
    const eliminarUbicacion = async () => {
        const respuesta = await consumirApi('DELETE', `maestros/ubicacion/${selectedId}`)
        if (respuesta.success) {
            setNotificacion({ estado: true, tipo: "eliminar", mensaje: "Ubicación eliminada correctamente" })
            limpiarCampos()
            obtenerUbicacion()
        } else {
            setError(respuesta.error)
        }
    }

    const limpiarCampos = () => {
        setMostrarModal(false)
        setMostrarModalEditar(false)
        setMostrarModalEliminar(false)
        setError('')
        setSelectedId(null)
        setDepartamento('')
        setProvincia('')
        setCiudad('')
        setCostoViatico('')
        setTimeout(() => {
            setIsSubmitting(false)
        }, 300)
    }

    return (
        <div className='w-full min-h-[calc(100vh-50px)]'>
            <Button className="ml-5 mt-2" texto='+ Nuevo' onClick={() => setMostrarModal(true)} />
            <Button className="ml-3 mt-2"  type="delete" disabled={!selectedId} onClick={()=> setMostrarModalEliminar(true)} />

            {notificacion.estado && (
                <Notification estadoNotificacion={setNotificacion} type={notificacion.tipo} mensaje={notificacion.mensaje} />
            )}
            {cargando ? (
                <Spinner />
            ) : (
                datos.length === 0 ? (
                    <div className="ml-5">No se encontraron ubicaciones</div>
                ) : (
                    <Table datos={datos} listaCampos={columnas} editarRegistro={abrirModalEditar}
                        mostrarChecks={true}
                        seleccionFila={seleccionUbicacion} // Manejar el ID seleccionado
                        selectedId={selectedId} // Manejar el ID seleccionado
                    />
                )
            )}

            {/* Modal Registrar nuevo Ubicación*/}
            <Modal isOpen={mostrarModal} title="Registrar nueva ubicación" onClose={limpiarCampos} >
                <Form onSubmit={registrarUbicacion} isSubmitting={isSubmitting}>
                    <Input name="departamento" value={departamento} label="Departamento" onChange={setDepartamento} />
                    <Input name="provincia" value={provincia} label="Provincia" onChange={setProvincia} />
                    <Input name="ciudad" value={ciudad} label="Ciudad" onChange={setCiudad} />
                    <Input name="costo_viatico" value={costoViatico} label="Costo viaticos" type="number" onChange={setCostoViatico} />
                    {error && <ErrorAlert message={error} />}
                </Form>
            </Modal>

            {/* Modal Actuazliar ubicacion*/}
            <Modal isOpen={mostrarModalEditar} title="Actualizar ubicación" onClose={limpiarCampos} >
                <Form onSubmit={enviarEdicionUbicacion}  isSubmitting={isSubmitting} type='update'>
                    <Input name="Departamento" value={departamento} label="departamento" onChange={setDepartamento} />
                    <Input name="Provincia" value={provincia} label="Provincia" onChange={setProvincia} />
                    <Input name="Ciudad" value={ciudad} label="Ciudad" onChange={setCiudad} />
                    <Input name="Costo viatico" value={costoViatico} label="Costo viatico" type="number" onChange={setCostoViatico} />
                    {error && <ErrorAlert message={error} />}
                </Form>
            </Modal>

            {/* Modal de confirmación para eliminar un accion*/}
            <ModalConfirmacion
                isOpen={mostrarModalEliminar}
                onClose={limpiarCampos}
                onConfirm={eliminarUbicacion}
                mensaje="¿Estás seguro de que deseas eliminar la ubicación?"
            >
                {error && <ErrorAlert message={error} />}
            </ModalConfirmacion>
        </div>
    )
}

export default Ubicacion
